import Message from "../../message";
import EventBus from "@/services/eventBus";

export default class SystemBroadcast extends Message
{
    handle()
    {
        EventBus.emit('system-broadcast', this.message);
    }
}
